import { render, staticRenderFns } from "./simpleRangeSlider.vue?vue&type=template&id=2485bbe8&scoped=true&"
import script from "./simpleRangeSlider.vue?vue&type=script&lang=ts&setup=true&"
export * from "./simpleRangeSlider.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./simpleRangeSlider.vue?vue&type=style&index=0&id=2485bbe8&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../vue2/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485bbe8",
  null
  
)

export default component.exports